import React, { forwardRef } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  withIcon?: boolean;
}
export const Button = forwardRef<HTMLButtonElement, ButtonProps>(({
  className = '',
  variant = 'primary',
  fullWidth = false,
  withIcon = false,
  children,
  ...props
}, ref) => {
  const baseStyles = 'inline-flex items-center justify-center rounded-md px-8 py-4 text-lg font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    primary: 'bg-[#FC8EAC] text-white hover:bg-[#E8739A] focus:ring-[#FC8EAC] shadow-md',
    secondary: 'bg-[#2C2C2C] text-white hover:bg-[#1a1a1a] focus:ring-[#2C2C2C]',
    outline: 'border-2 border-[#FC8EAC] text-[#FC8EAC] hover:bg-[#FC8EAC] hover:text-white focus:ring-[#FC8EAC]'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <motion.button ref={ref} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-221">
        {children}
        {withIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-222" />}
      </motion.button>;
});
Button.displayName = 'Button';